import { generateToken } from "./firebase";

// prevent duplicate / excessive syncs per user/app
const inFlight = new Map();
const lastSync = new Map();
const COOLDOWN_MS = 60 * 1000; // 1 minute cooldown between sync attempts

function browserDeviceId() {
  let id = localStorage.getItem("flyspaBrowserDeviceId");
  if (!id) {
    id = window.crypto?.randomUUID?.() || `web-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("flyspaBrowserDeviceId", id);
  }
  return id;
}

// Registers the current browser's FCM web token for the given user.
export async function syncWebToken({ userId, appName, axios }) {
  const key = `${appName || "web"}:${userId || "anon"}`;
  const now = Date.now();
  const last = lastSync.get(key);
  if (last && now - last < COOLDOWN_MS) return true;

  if (inFlight.get(key)) return inFlight.get(key);
  let token = localStorage.getItem("firebaseToken");
  if (!token) {
    token = await generateToken();
  }
  if (!token || !userId) return false;

  lastSync.set(key, now);
  const promise = axios.post(`/tokens`, {
    fcm_web_token: token,
    device_id: browserDeviceId(),
    token_type: "web",
    app_name: appName,
  }).then(() => true).finally(() => {
    inFlight.delete(key);
  });

  inFlight.set(key, promise);
  return promise;
}

// Marks the current web token as inactive during logout.
export async function deactivateWebToken({ appName, axios }) {
  const token = localStorage.getItem("firebaseToken");
  if (!token) return false;
  await axios.post("/tokens/deactivate", {
    fcm_web_token: token,
    device_id: browserDeviceId(),
    token_type: "web",
    app_name: appName,
  });
  return true;
}
